<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="file_journey_type_list" dense class="elevation-1 mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>File Journey Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="2" cols="12"> </v-col>
            <v-col sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>
                  Add File Journey Type
                </v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete :items="file_journey_type_super_master"
                            v-model="editedItem.file_journey_type_super_master" label="Select File Journey Type"
                            :rules="[(v) => !!v || 'required']" :disabled="editedIndex != -1"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.initial" persistent-hint :rules="[(v) => !!v || 'required']"
                            hint="I for Inward, O for Outward..." label="Display Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    // extraBreadcrumbItems: [
    //   { text: "File Journey Type", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",

    // breadcrumbClass: "breadcrumb-style2",
    valid: false,
    overlay: false,
    errorMsg: {
      initial: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    file_journey_type_super_master: null,
    initial: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Initials",
        align: "left",
        sortable: false,
        value: "initial",
      },
      {
        text: "Active",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false, align: "left" },
    ],
    file_journey_type_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      initial: "",
      isactive: true,
      file_journey_type_super_master: "",
    },
    defaultItem: {
      id: "",
      name: "",
      initial: "",
      isactive: true,
      file_journey_type_super_master: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New File Journey Type"
        : "Edit File Journey Type";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },

  methods: {
    //   initialize () {
    file_journey_type_super_master() {
      this.errorMsg.initial = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/InwardOutward/fileJourneyTypeHome")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.file_journey_type_super_master =
                res.data.file_journey_type_super_master;
              this.file_journey_type_list = res.data.file_journey_type_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.file_journey_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      // this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/InwardOutward/editFileJourneyType", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.file_journey_type_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "File Journey Type Updated Successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/InwardOutward/saveFileJourneyType", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.file_journey_type_list.push(this.editedItem);
              this.showSnackbar("#4caf50", res.data.status.message); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", res.data.status.message); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/InwardOutward/toggleFileJourneyType", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "File Journey Type Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    isValidated() {
      if (this.editedItem.initial) {
        return true;
      } else {
        if (!this.editedItem.initial) {
          this.errorMsg.initial = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
